<template>
    <div class="boxMessage" :class="`boxMessage--${type}`">
        <div class="boxMessage__text">
            <div v-if="icon" class="boxMessage__icon">
                <img
                    v-lazy-load
                    src="/nuxt-assets/images/lazy-load-error.svg"
                    :data-src="`/nuxt-assets/images/icons/${icon}.svg`"
                    :alt="icon"
                />
            </div>
            <span v-html="text" />
        </div>
        <button v-if="buttonText" class="boxMessage__button btn btn-outline-primary" @click.prevent="buttonClick">{{ buttonText }}</button>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        text: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'primary',
        },
        icon: {
            type: String,
            default: '',
        },
        buttonText: {
            type: String,
            default: '',
        },
    },

    methods: {
        buttonClick() {
            useNuxtApp().$bus.$emit('click-button')
        },
    },
}
</script>

<style lang="scss" scoped>
.boxMessage {
    border-radius: 10px;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    padding: 10px;
    margin-bottom: 13px;
    text-align: center;
    display: flex;

    @media (min-width: 768px) {
        display: flex;
        align-items: center;
    }

    &--primary {
        color: $color-cta;
        background: $color-cta-extra-light;
    }

    &--success {
        color: $color-green-dark;
        background: $color-green-light;
    }

    &__icon {
        display: inline-block;
        margin-right: 10px;

        &:deep(svg) {
            width: 18px;
            height: 18px;
        }
    }

    &__text {
        flex: 1;
        font-weight: normal;
        text-align: left;
        display: flex;
        align-items: center;
        line-height: 20px;

        :deep(strong) {
            font-size: 18px;
            font-weight: bold;
        }

        @media (min-width: 768px) {
            margin-left: 10px;
            font-size: 14px;
        }
    }

    &__button {
        padding: 5px 17px;
        background: transparent;

        @media (min-width: 768px) {
            margin: 0 0 0 10px;
        }

        &:hover {
            background: $color-cta;
            color: $color-cta-extra-light;
        }
    }
}
</style>
